import { LabsFlag } from '../../../enums/labsFlag'
import { useLabsMenuFlags } from '../../../hooks/useLabsMenuFlags'

interface UseImportedInvoiceReviewFeatureResult {
  isEnabled: boolean
}

/**
 * Gates the review drawer and row click — not the list by itself. Flag-off is the
 * behaviour that ships today.
 *
 * Turning this on also opens the list (`useImportedInvoicesFeature`), so the drawer can
 * be reached without a Cegid-eligible org.
 */
export const useImportedInvoiceReviewFeature = (): UseImportedInvoiceReviewFeatureResult => {
  const labsFlags = useLabsMenuFlags()

  return { isEnabled: labsFlags[LabsFlag.ImportedInvoiceReview] }
}
